var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar"},[_c('div',{staticClass:"avatar__picture"},[_c('img',{staticClass:"avatar__symbol",attrs:{"src":_vm.avatar + '&background=0A76BD',"alt":_vm.name}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }